import React from 'react';
import { Typography } from '@smooth-ui/core-sc';

const Banner = () => (
  <Typography variant="h1" textAlign="center" m={0}>
    KITKAT or CANDLE
  </Typography>
);

export default Banner;